import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import BackOfficeLayout from "../../../components/backoffice-layout";
import CoreAPI from "../../../services/core";
import LoadingModal from "../../../components/loading-modal";
import EFDashboardComponent from "../../../components/dashboard/ef-dashboard";
import ButtonComponent from "../../../components/button";
import IconCompare from "../../../assets/images/icon-compare.svg"
import { onSleep } from "../../../utils/default";

const Container = styled.div`
    width: calc(100% - 32px);
    background-color: #FFFFFF;
    padding: 40px 16px;
    border-radius: 16px;

    .header-box {
        height: 56px;
        display: flex;
        justify-content: space-between;
        margin-bottom: 24px;

        .header-label {
            width: fit-content;
            color: #25368D;
            font-size: 20px;
            font-weight: 600;
            line-height: 29.9px;
            text-align: left;
            padding: 2px;
            border-width: 0px 0px 3px 0px;
            border-style: solid;
            border-color: #25368D;
        }
    }

    .data-box {
        display: flex;
        flex-direction: column;
        gap: 24px;
    }
`;

function DashboardPage() {
    const [isLoading, setIsLoading] = useState(false);
    const [listDepartment, setListDepartment] = useState([]);
    const [userProfile, setUserProfile] = useState(null);
    const [listDashboard, setListDashboard] = useState([
        {
            id: (new Date()).getTime().toString(),
            body: null,
            response: null,
        },
    ])
    const [isAdd, setIsAdd] = useState(false);
    const observeChart = useRef(null);

    useEffect(() => {
        onInit();

        return () => {
            if (observeChart.current) {
                clearInterval(observeChart.current)
            }
        }
    }, [])

    async function onInit() {
        setIsLoading(true);
        let _profile = localStorage.getItem("profile");
        try {
            _profile = JSON.parse(_profile)
        } catch { }

        if (_profile) {
            setUserProfile(_profile);
            if (_profile.user_department_id) {
                await onGetDepartmentById(_profile.user_department_id)
            } else {
                await onGetAllDepertment()
            }
        }
        // observeChart.current = setInterval(() => {
        //     console.log("observeChart.current")
        //     onSetPositionBarLabel(0);
        // }, 5000);
        setIsLoading(false);
    }
    async function onGetDepartmentById(id) {
        let response = [];
        try {
            response = await CoreAPI.userHttpService.userGetDepertmentById(id)
        } catch { }
        if (response) {
            let list = [];
            const detail = {
                id: response.department_id,
                label: response.department_name,
            }
            list.push(detail);
            response = [...list]
        }
        setListDepartment(response)
        return response;
    }
    async function onGetAllDepertment() {
        let response = null;
        try {
            response = await CoreAPI.userHttpService.userGetAllDepertment()
        } catch { }
        if (response) {
            let list = [];
            if (Array.isArray(response)) {
                list = JSON.parse(JSON.stringify(response));
                list = list.map(x => {
                    const detail = {
                        id: x.department_id,
                        label: x.department_name,
                    }
                    return detail
                })
            }
            response = [...list]
        }
        setListDepartment(response)
        return response;
    }
    async function onSetPositionBarLabel(param) {
        const count_max = 10;
        let checkChange = true;
        let elements = document.getElementsByClassName("MuiBarLabel-root");
        await onSleep(100);
        if (elements.length > 0) {
            for (let item of elements) {
                if (item.style?.height?.includes("px")) {
                    const height = Number(item.style?.height?.replace("px", ""))
                    const transform = item.style?.transform
                    const transformSplit = transform?.split(",")
                    if (Array.isArray(transformSplit) && transformSplit.length > 2) {
                        const height_old = transformSplit[1];
                        if (!isNaN(height)) {
                            const chart_height = 300 - 100;
                            let height_new = chart_height - height + 50;
                            if (chart_height - height === 0) {
                                height_new = height_new + 10;
                            } else {
                                height_new = height_new - 10;
                            }
                            const transform_new = item.style.transform.replace(`,${height_old},`, `, ${height_new}px,`);
                            // item.style.transform = transform_new;
                            if (transform !== transform_new) {
                                checkChange = false;
                            }
                        }
                    }
                }
            }
        }
        if (!checkChange && param < count_max) {
            const count = param + 1;
            onSetPositionBarLabel(count)
        }
    }

    function handleEnter(param, index) {
        let list = JSON.parse(JSON.stringify(listDashboard));
        list[index] = { 
            ...list[index],
            ...param 
        };
        setListDashboard(list);
        setIsAdd(true)
    }
    function handleAdd() {
        let list = JSON.parse(JSON.stringify(listDashboard));
        list.push({
            id: (new Date()).getTime().toString(),
            body: null,
            response: null,
        })
        setListDashboard(list)
        setIsAdd(false)
    }
    function handleRemove(index) {
        let list = JSON.parse(JSON.stringify(listDashboard));
        list.splice(index, 1)
        setListDashboard(list)
    }

    return (
        <BackOfficeLayout>
            <LoadingModal open={isLoading} />
            <Container>
                <div className="data-box">
                    {listDashboard.map((value, index) => {
                        return (
                            <EFDashboardComponent
                                key={value.id}
                                indexComponent={index}
                                deleteable={listDashboard.length > 1}
                                userProfile={userProfile}
                                departments={listDepartment}
                                onEnter={(e) => handleEnter(e, index)}
                                onRemove={(e) => handleRemove(index)}
                            />
                        )
                    })}
                    {isAdd &&
                        <ButtonComponent
                            label={"เปรียบเทียบแบบสอบถาม"}
                            variant={"primary"}
                            icon={IconCompare}
                            sceenSize={"lg"}
                            style={{ width: "260px", maxWidth: "260px", minWidth: "260px", marginLeft: "auto", marginRight: "0px" }}
                            onClick={handleAdd}
                        />
                    }
                </div>
            </Container>
        </BackOfficeLayout>
    )
}

export default DashboardPage;